<app-tab-grid
  i18n-name
  name="Addressees"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  (create)="create()"
  (edit)="edit($event)"
  (delete)="delete($event)"
></app-tab-grid>
